import MuiButton, { type ButtonProps as MuiButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export interface ButtonProps extends MuiButtonProps {
  loading?: boolean;
}

/**
 * Thin, presentational wrapper around MUI's Button. Purely props/callbacks —
 * no data fetching, no store access. Safe to reuse in any app built on this
 * template.
 */
export function Button({ loading = false, disabled, children, ...rest }: ButtonProps) {
  return (
    <MuiButton disabled={disabled || loading} {...rest}>
      {loading ? <CircularProgress size={20} color="inherit" /> : children}
    </MuiButton>
  );
}
